import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Home, {HomePageLoader} from "./pages/home/Home";
import Login from "./pages/login/Login";
import Layout from "./pages/Layout";
import Tournament, {TournamentPageLoader} from "./pages/tournament/Tournament";
import RootLayout from "./pages/RootLayout";
import Post, {PostPageLoader} from "./pages/posts/Post";
import CreateUser, {CreateUserPageLoader} from "./pages/user/create/CreateUser";
import Show, {ShowPageLoader} from "./pages/user/show/Show";
import EditUser, {EditUserPageLoader} from "./pages/user/edit/EditUser";
import TournamentDetails, {TournamentDetailsPageLoader} from "./pages/tournamentDetails/TournamentDetails";
import Step, {StepPageLoader} from "./pages/step/Step";
import ScientificContest, {ScientificContestPageLoader} from "./pages/scientificژontest/ScientificContest";
import Support from "./pages/support/Support";
import HseManagerTeams, {HseManagerTeamsLoader} from "./pages/hse-manager/HseManagerTeams";
import AssignSupervisor, {AssignSupervisorLoader} from "./pages/hse-manager/AssignSupervisor";
import EditSupervisor, {EditSupervisorLoader} from "./pages/hse-manager/EditSupervisor";

const router = createBrowserRouter([
    {
        path: '/', element: <RootLayout/>, children: [
            {path: '/login', element: <Login/>},
            {
                path: '/', loader: HomePageLoader, element: <Home/>
            },
            {
                path: '/tournament/:id', element: <Layout/>, children: [
                    {
                        index: true, loader: TournamentPageLoader, element: <Tournament/>
                    },
                    {
                        path: 'steps', loader: TournamentDetailsPageLoader, element: <TournamentDetails/>
                    },
                    {
                        path: 'step/:step_id', loader: StepPageLoader, element: <Step/>
                    },
                    {
                        path: 'step/scientific-contest',
                        loader: ScientificContestPageLoader,
                        element: <ScientificContest/>
                    },
                    {
                        path: 'team/posts', loader: PostPageLoader, element: <Post/>
                    },
                    {
                        path: 'team/posts/:post_id/create',
                        loader: CreateUserPageLoader, element: <CreateUser/>
                    },
                    {
                        path: 'team/posts/:post_id/show',
                        loader: ShowPageLoader, element: <Show/>
                    },
                    {
                        path: 'team/posts/:post_id/edit',
                        loader: EditUserPageLoader, element: <EditUser/>
                    },
                    {
                        path: 'hse-manager/teams',
                        loader: HseManagerTeamsLoader, element: <HseManagerTeams/>
                    },
                    {
                        path: 'hse-manager/teams/:team_id/assign-supervisor',
                        loader: AssignSupervisorLoader, element: <AssignSupervisor/>
                    },
                    {
                        path: 'hse-manager/teams/:team_id/edit-supervisor',
                        loader: EditSupervisorLoader, element: <EditSupervisor/>
                    },
                ]
            },
            {
                path: '/support', element: <Support/>
            }
        ]
    },
])

function App() {
    return <RouterProvider router={router}/>
}

export default App;
